import { render, staticRenderFns } from "./SocialNetworksConfig.vue?vue&type=template&id=72fa13d1&scoped=true"
import script from "./SocialNetworksConfig.vue?vue&type=script&lang=js"
export * from "./SocialNetworksConfig.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworksConfig.vue?vue&type=style&index=0&id=72fa13d1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa13d1",
  null
  
)

export default component.exports